// ─────────────────────────────────────────────
// DATE RANGE PICKER
// ─────────────────────────────────────────────
import { useState, useEffect, useMemo, createContext, useContext } from "react";
import {DARK_THEME_PAINEL_EXECUTIVO , LIGHT_THEME_PAINEL_EXECUTIVO} from '../componets/temas'

export const ThemeContext = createContext(LIGHT_THEME_PAINEL_EXECUTIVO);

const toInputValue = (d) => {
  const y   = d.getFullYear();
  const m   = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

const formatDisplay = (d) =>
  `${String(d.getDate()).padStart(2,"0")}/${String(d.getMonth()+1).padStart(2,"0")}/${d.getFullYear()}`;

export const DateRangePicker = ({ value, onChange }) => {
  const C = useContext(ThemeContext);
  const [open, setOpen]         = useState(false);
  const [tempStart, setTempStart] = useState(toInputValue(value.start));
  const [tempEnd,   setTempEnd]   = useState(toInputValue(value.end));

  const apply = () => {
    if (!tempStart || !tempEnd) return;
    const start = new Date(tempStart + "T00:00:00");
    const end   = new Date(tempEnd   + "T00:00:00");
    if (start > end) return;
    onChange({ start, end });
    setOpen(false);
  };

  const inputStyle = {
    background: C.inputBg,
    border: `1px solid ${C.border}`,
    borderRadius: 6,
    color: C.text,
    padding: "7px 10px",
    fontSize: 13,
    cursor: "pointer",
    colorScheme: C.inputBg === DARK_THEME_PAINEL_EXECUTIVO.inputBg ? "dark" : "light",
    width: "100%",
  };

  return (
    <div style={{ position:"relative" }}>
      <button
        onClick={() => setOpen(!open)}
        style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:8, color:C.text, padding:"8px 16px", cursor:"pointer", fontSize:13, display:"flex", alignItems:"center", gap:8 }}
      >
        {formatDisplay(value.start)} – {formatDisplay(value.end)}
      </button>
      {open && (
        <div style={{ position:"absolute", right:0, top:"calc(100% + 8px)", zIndex:200, background:C.card, border:`1px solid ${C.border}`, borderRadius:10, padding:20, display:"flex", flexDirection:"column", gap:14, minWidth:280, boxShadow:C.shadowCard }}>
          <div style={{ fontSize:11, fontWeight:700, color:C.muted, letterSpacing:"0.08em", textTransform:"uppercase" }}>Período personalizado</div>
          <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
            <label style={{ fontSize:11, color:C.muted }}>Data inicial</label>
            <input type="date" value={tempStart} onChange={(e) => setTempStart(e.target.value)} style={inputStyle} />
          </div>
          <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
            <label style={{ fontSize:11, color:C.muted }}>Data final</label>
            <input type="date" value={tempEnd} min={tempStart} onChange={(e) => setTempEnd(e.target.value)} style={inputStyle} />
          </div>
          <div style={{ borderTop:`1px solid ${C.border}`, paddingTop:12, display:"flex", flexDirection:"column", gap:6 }}>
            <div style={{ fontSize:11, color:C.muted, marginBottom:2 }}>Atalhos</div>
            {[
              { label:"Ano 2025", s:"2025-01-01", e:"2025-12-31" },
              { label:"Ano 2026", s:"2026-01-01", e:"2026-12-31" },
            ].map((opt) => (
              <button key={opt.label} onClick={() => { setTempStart(opt.s); setTempEnd(opt.e); }} style={{
                background:"transparent", border:`1px solid ${C.border}`, borderRadius:6,
                color:C.text, padding:"7px 10px", cursor:"pointer", fontSize:12, textAlign:"left",
              }}>
                {opt.label}
              </button>
            ))}
          </div>
          <div style={{ display:"flex", gap:8 }}>
            <button onClick={() => setOpen(false)} style={{ flex:1, background:"transparent", border:`1px solid ${C.border}`, borderRadius:6, color:C.muted, padding:"8px", cursor:"pointer", fontSize:12 }}>Cancelar</button>
            <button onClick={apply} style={{ flex:1, background:C.brand, border:"none", borderRadius:6, color:"white", padding:"8px", cursor:"pointer", fontSize:12, fontWeight:600 }}>Aplicar</button>
          </div>
        </div>
      )}
    </div>
  );
};